import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'app-countdown-timer',
    templateUrl: './countdown-timer.component.html',
    styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
    @Input() startDate!: Date; // Kezdő időpont
    @Input() pickingTime!: number; // Másodpercekben az elvégzési idő

    remainingTime: number = 0;
    timerSubscription!: Subscription;

    ngOnInit(): void {
        this.calculateRemainingTime();
        this.startCountdown();
    }

    private calculateRemainingTime() {
        const startTime = new Date(this.startDate).getTime();
        const endTime = startTime + this.pickingTime * 1000; // Végidő milliszekundumban
        this.remainingTime = Math.floor((endTime - Date.now()) / 1000); // Másodpercekben
    }

    private startCountdown() {
        this.timerSubscription = interval(1000).subscribe(() => {
            this.remainingTime = Math.floor(
                (new Date(this.startDate).getTime() +
                    this.pickingTime * 1000 -
                    Date.now()) /
                    1000
            );
        });
    }

    formatTime(seconds: number): string {
        const absSeconds = Math.abs(seconds);
        const hours = Math.floor(absSeconds / 3600);
        const minutes = Math.floor((absSeconds % 3600) / 60);
        const secs = absSeconds % 60;

        const formattedTime =
            `${hours.toString().padStart(2, '0')}:` +
            `${minutes.toString().padStart(2, '0')}:` +
            `${secs.toString().padStart(2, '0')}`;

        return seconds < 0 ? `-${formattedTime}` : formattedTime;
    }

    ngOnDestroy(): void {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
}
